import script from "./Permissions.vue?vue&type=script&setup=true&lang=js"
export * from "./Permissions.vue?vue&type=script&setup=true&lang=js"

import "./Permissions.vue?vue&type=style&index=0&id=6b4ab4e0&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6b4ab4e0"]])

export default __exports__